import React from 'react';
import './Privacy.css'; // Reuse legal page styles

function Terms() {
  return (
    <section className="page legal-page">
      <h1>Terms of Service</h1>
      <p className="last-updated">Last updated: December 5, 2025</p>

      <h2>1. Acceptance of Terms</h2>
      <p>
        By accessing or using IQLedger and related services provided by IQTechnologies ("we," "our," 
        or "us"), you agree to be bound by these Terms of Service. If you do not agree to these 
        terms, do not use our services.
      </p>

      <h2>2. Description of Service</h2>
      <p>
        IQLedger is an audit logging platform for AI and LLM applications. Our service allows you 
        to capture, store, and analyze interactions between your applications and large language 
        models, with built-in PII redaction and compliance features.
      </p>

      <h2>3. Account Registration</h2>
      <p>
        To use our services, you must create an account and provide accurate, complete information. 
        You are responsible for maintaining the security of your account credentials and for all 
        activities that occur under your account.
      </p>

      <h2>4. Acceptable Use</h2>
      <p>You agree not to:</p>
      <ul>
        <li>Use our services for any unlawful purpose</li>
        <li>Attempt to gain unauthorized access to our systems</li>
        <li>Interfere with or disrupt the integrity of our services</li>
        <li>Upload malicious code or content</li>
        <li>Resell or redistribute our services without authorization</li>
        <li>Use our services to store content that violates third-party rights</li>
      </ul>

      <h2>5. Data Ownership</h2>
      <p>
        You retain all rights to the data you submit to IQLedger. We do not claim ownership of 
        your log data. We only access your data as necessary to provide the service or as 
        required by law.
      </p>

      <h2>6. Subscription and Billing</h2>
      <p>
        Paid subscriptions are billed in advance on a monthly basis. All fees are non-refundable 
        except as required by law. We reserve the right to change our pricing with 30 days notice.
      </p>
      <h3>Plan Limits</h3>
      <p>
        Each plan includes a monthly token allowance. Usage beyond your plan's limits may result 
        in service restrictions until the next billing cycle or upgrade to a higher tier.
      </p>

      <h2>7. Service Availability</h2>
      <p>
        We strive to maintain high availability but do not guarantee uninterrupted access. We may 
        perform scheduled maintenance with reasonable notice. We are not liable for any downtime 
        or service interruptions.
      </p>

      <h2>8. Data Security</h2>
      <p>
        We implement industry-standard security measures to protect your data. However, no method 
        of electronic transmission or storage is 100% secure. You acknowledge this inherent risk.
      </p>

      <h2>9. Limitation of Liability</h2>
      <p>
        To the maximum extent permitted by law, IQTechnologies shall not be liable for any 
        indirect, incidental, special, consequential, or punitive damages, or any loss of 
        profits or revenues, whether incurred directly or indirectly.
      </p>
      <p>
        Our total liability for any claims arising from these terms or your use of the service 
        shall not exceed the amount you paid us in the 12 months preceding the claim.
      </p>

      <h2>10. Indemnification</h2>
      <p>
        You agree to indemnify and hold harmless IQTechnologies and its officers, directors, 
        employees, and agents from any claims, damages, or expenses arising from your use of 
        the service or violation of these terms.
      </p>

      <h2>11. Termination</h2>
      <p>
        You may cancel your account at any time through the Settings page. We may suspend or 
        terminate your account for violation of these terms. Upon termination, your data will 
        be deleted according to our retention policies.
      </p>

      <h2>12. Changes to Terms</h2>
      <p>
        We may modify these terms at any time. We will notify you of material changes via email 
        or through the service. Continued use after changes constitutes acceptance of the new terms.
      </p>

      <h2>13. Governing Law</h2>
      <p>
        These terms are governed by the laws of the State of Delaware, without regard to conflict 
        of law provisions. Any disputes shall be resolved in the courts of Delaware.
      </p>

      <h2>14. Contact</h2>
      <p>
        For questions about these Terms of Service, please contact us at:
      </p>
      <p>
        <a href="mailto:legal@iqtechnologies.ai">legal@iqtechnologies.ai</a>
      </p>
    </section>
  );
}

export default Terms;
